/* Start Section dosec_zive_14mar_wwai_clinical_results_yXGicJ */
document.addEventListener('DOMContentLoaded',function(){var Swipes=new Swiper('.section-template--dosec_zive_14mar_wwai_clinical_results_yXGicJ .swiper',{loop:false,slidesPerView:1,spaceBetween:15,grabCursor:false,initialSlide:0,roundLengths:true,navigation:{nextEl:'.section-template--dosec_zive_14mar_wwai_clinical_results_yXGicJ .next',prevEl:'.section-template--dosec_zive_14mar_wwai_clinical_results_yXGicJ .prev',clickable:true,},pagination:{el:".section-template--dosec_zive_14mar_wwai_clinical_results_yXGicJ .dots",clickable:true},breakpoints:{768:{slidesPerView:2,centeredSlides:false,loop:false,initialSlide:0,spaceBetween:22},1199:{slidesPerView:3,centeredSlides:false,loop:false,initialSlide:0,spaceBetween:22}},on:{init:function(){updateNavigationVisibility(this);},resize:function(){updateNavigationVisibility(this);},slideChange:function(){updateNavigationVisibility(this);}}});function updateNavigationVisibility(swiper){const totalSlides=swiper.slides.length;const slidesPerView=swiper.params.slidesPerView;const canShowAllSlides=totalSlides<=slidesPerView;const sliderControls=document.querySelector('.section-template--dosec_zive_14mar_wwai_clinical_results_yXGicJ .slider-controls');if(canShowAllSlides){sliderControls.style.display='none';}else{sliderControls.style.display='';}}});
/* End Section dosec_zive_14mar_wwai_clinical_results_yXGicJ */
/* Start Section dosec_zive_14mar_wwai_ingredients_LWyqiU */
document.addEventListener('DOMContentLoaded',function(){const divs=document.querySelectorAll('.ing_container_container_class_section');divs.forEach(function(div){div.addEventListener('click',function(){div.classList.toggle('active');divs.forEach(function(otherDiv){if(otherDiv!=div){otherDiv.classList.remove('active');}});});});});
/* End Section dosec_zive_14mar_wwai_ingredients_LWyqiU */
/* Start Section dosec_zive_14mar_wwai_reviews_8acULd */
document.addEventListener('DOMContentLoaded',function(){const swiper=new Swiper('.swiper-container',{slidesPerView:1,spaceBetween:25,loop:false,slidesPerGroup:1,pagination:{el:'.dots',clickable:true,},navigation:{nextEl:'.next',prevEl:'.prev',},breakpoints:{768:{slidesPerView:3,slidesPerGroup:3,},},});});document.addEventListener("DOMContentLoaded",function(){const readMoreButtons=document.querySelectorAll('.read_more_button_button_class_section');const modal=document.getElementById('review-modal');const customDetailsContainer=document.getElementById('custom-review-details');function openModalMobile(customDetails){customDetails.classList.toggle('active');}
function openModal(customDetails){customDetailsContainer.innerHTML=customDetails;modal.style.display="flex";}
function closeModalFunction(){modal.style.display="none";}
readMoreButtons.forEach(function(button){button.addEventListener('click',function(event){event.preventDefault();const customDetails=button.closest('[data-container]').querySelector('.review_more_details_container').innerHTML;const btnTextWrap=button.closest('[data-content-wrap]');if(window.innerWidth<768){openModalMobile(btnTextWrap);}else{openModal(customDetails);}});});document.querySelector('.section-template--dosec_zive_14mar_wwai_reviews_8acULd .popup_close_text').addEventListener('click',function(){closeModalFunction();});document.querySelector('.section-template--dosec_zive_14mar_wwai_reviews_8acULd .reviews_main_container').addEventListener('click',function(event){if(event.target==modal){closeModalFunction();}});});
/* End Section dosec_zive_14mar_wwai_reviews_8acULd */
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});
if (!customElements.get('carousel-slider')) {
class CarouselSlider extends HTMLElement {
  constructor() {
    super();
    this.activeIndex = 0;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.cacheElements();
    this.bindEvents();
    this.scrollToMediaItem(this.activeIndex);
  }

  cacheElements() {
    this.mainMedia = this.querySelector('main-slider');
    this.thumbSlider = this.querySelector('thumb-slider');
    this.thumbVertical = this.thumbSlider?.dataset.vartical;
    this.pagenation = this.querySelector('pagenation');
    this.mediaItems = this.mainMedia?.querySelectorAll('main-slider-slide') || [];
    this.thumbItems = this.thumbSlider?.querySelectorAll('thumb-slider-slide') || [];
    this.pageItems = this.pagenation?.querySelectorAll('button.page-media-item') || [];
  }

  bindEvents() {
    const mediaBtnNext = this.querySelector('.media-next');
    const mediaBtnPrev = this.querySelector('.media-prev');

    mediaBtnNext?.addEventListener('click', () => this.goToNext());
    mediaBtnPrev?.addEventListener('click', () => this.goToPrev());

    this.thumbItems.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this.scrollToMediaItem(index));
    });
    
    this.pageItems.forEach((page, index) => {
      page.addEventListener('click', () => this.scrollToMediaItem(index));
    });
    
    let scrollTimeout = null;
    this.mainMedia?.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => this.handleScrollSnap(), 200);
    });
    
    const updateThumbSliderHeight = () => {
      if (this.thumbVertical && window.innerWidth > 768) {
        this.thumbSlider.style.maxHeight = this.mainMedia.offsetHeight + 'px';
      } else {
        this.thumbSlider.style.maxHeight = ''; // Optional: reset height on small screens
      }
    };
  
    setTimeout(updateThumbSliderHeight, 200);
  
    window.addEventListener('resize', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateThumbSliderHeight, 200);
    });
  }

  handleScrollSnap() {
    const scrollLeft = this.mainMedia.scrollLeft;
    const itemWidth = this.mediaItems[0]?.clientWidth || 0;
    const offset = scrollLeft + this.mainMedia.offsetLeft;

    let closestIndex = 0;
    let minDiff = Infinity;
    this.mediaItems.forEach((item, i) => {
      const diff = Math.abs(item.offsetLeft - offset);
      if (diff < minDiff) {
        minDiff = diff;
        closestIndex = i;
      }
    });

    this.scrollToMediaItem(closestIndex);
  }

  goToNext() {
    if (this.activeIndex < this.mediaItems.length - 1) {
      this.scrollToMediaItem(this.activeIndex + 1);
    }
  }

  goToPrev() {
    if (this.activeIndex > 0) {
      this.scrollToMediaItem(this.activeIndex - 1);
    }
  }

  scrollToMediaItem(index) {
    if (!this.mediaItems.length) return;

    this.mediaItems[this.activeIndex]?.classList.remove('active');
    this.thumbItems[this.activeIndex]?.classList.remove('active');
    this.pageItems[this.activeIndex]?.classList.remove('active');

    this.activeIndex = index;

    this.mediaItems[this.activeIndex]?.classList.add('active');
    this.thumbItems[this.activeIndex]?.classList.add('active');
    this.pageItems[this.activeIndex]?.classList.add('active');

    const scrollLeft = this.mediaItems[this.activeIndex].offsetLeft - this.mainMedia.offsetLeft;
    this.mainMedia.scrollTo({ left: scrollLeft, behavior: 'smooth' });

    const thumbScroll = this.thumbItems[this.activeIndex].offsetLeft - this.thumbSlider.offsetLeft - ((this.thumbSlider.clientWidth / 2) - (this.thumbItems[this.activeIndex].clientHeight / 2));
    this.thumbSlider.scrollTo({ left: thumbScroll, behavior: 'smooth' });
  }

  refresh(index = 0) {
    this.activeIndex = index;
    this.cacheElements();
    this.bindEvents();
  }

  createCustomCarouselSlide(data, isThumbnail = false) {
    const slideTag = isThumbnail ? 'thumb-slider-slide' : 'main-slider-slide';
    const slideClass = isThumbnail ? 'thumb-media-item' : 'main-media-item';
    const slide = document.createElement(slideTag);
    slide.className = slideClass;
    slide.id = isThumbnail ? undefined : `wwai-media-${data.id}`;

    const img = document.createElement('img');
    img.src = isThumbnail ? `${data.src}&width=${data.width}` : data.src;
    img.alt = data.alt || "Image";
    img.width = data.width;
    img.height = data.height;
    img.loading = 'lazy';
    img.className = isThumbnail ? 'thumb-media-img' : 'main-media-img';

    const srcset = isThumbnail
      ? `${data.src}&width=${data.width} ${data.width}w`
      : [
          `${data.src}&width=352 352w`,
          `${data.src}&width=832 832w`,
          `${data.src}&width=1200 1200w`,
          `${data.src}&width=1920 1920w`,
          `${data.src}&width=2561 2561w`
        ].join(', ');

    img.setAttribute('srcset', srcset);
    img.setAttribute('sizes', '(min-width: 1536px) 1500px,(min-width: 1280px) 1250px,(min-width: 768px) 994px,(min-width: 768px) 708px,(min-width: 640px) 610px,100vw');

    if (isThumbnail) {
      slide.setAttribute('data-handle', `media-${data.id}`);
      slide.setAttribute('data-img-id', data.src);
    }

    slide.appendChild(img);
    return slide;
  }

  gotoSlide(index) {
    if (!this.mediaItems.length) return;

    if (index < 0) {
      const resolvedIndex = this.mediaItems.length + index;
      this.scrollToMediaItem(resolvedIndex);
    } else {
      this.scrollToMediaItem(index);
    }
  }

  clearSlides() {
    this.mainMedia.innerHTML = '';
    this.thumbSlider.innerHTML = '';
    this.mediaItems = [];
    this.thumbItems = [];
    this.activeIndex = 0;
  }
}

customElements.define('carousel-slider', CarouselSlider);
}